import { transformObjectToQuery } from '../../URI/helpers.js';
import { convertObjectToFormData } from '../utils/convertObjectToFormData.js';
export class HTTPRequestConfig {
    url;
    headers;
    requestType;
    _withCredentials;
    model;
    bodyAsEncodeString;
    transformBodyToLegacyString;
    _cachedBody;
    constructor(params) {
        this.model = params.model;
        this.bodyAsEncodeString = params.bodyAsEncodeString;
        this.transformBodyToLegacyString = params.transformBodyToLegacyString;
        this.requestType = params.model.requestType || (params.bodyAsEncodeString ? 'string' : 'json');
        this._withCredentials = params.withCredentials;
        this.url = params.url;
        this.headers = params.headers;
    }
    get body() {
        const { parameters, method } = this.model;
        if (!parameters || method === 'GET') {
            return undefined;
        }
        if (!this._cachedBody) {
            switch (this.requestType) {
                case 'json':
                    this._cachedBody = JSON.stringify(parameters);
                    break;
                case 'string':
                    if (this.bodyAsEncodeString) {
                        this._cachedBody = transformObjectToQuery(parameters, this.transformBodyToLegacyString);
                    }
                    else {
                        this._cachedBody = parameters;
                    }
                    break;
                case 'formData':
                    this._cachedBody = convertObjectToFormData(parameters);
                    break;
                default:
                    this._cachedBody = parameters;
            }
        }
        return this._cachedBody;
    }
    get method() {
        return this.model.method;
    }
    get withCredentials() {
        if (this.model.apiType === 'external') {
            return this._withCredentials;
        }
        return typeof this._withCredentials === 'undefined' || !!this._withCredentials;
    }
    get isExternal() {
        return this.model.apiType === 'external';
    }
}
//# sourceMappingURL=HTTPRequestConfig.js.map